export const TariffType = {
  BasicSet: 1,
  PlusSet: 2,
  ProSet: 3,
  MaxRenderSet: 4,
  MultiSetPro: 6,
};
